import React from 'react'
import Link from 'gatsby-link'



const ContactPage = ({ transition }) => (
  <div style={transition && transition.style}>
    <h1 className="pages_head">Contact Me</h1>
    <form name="contacting_select" method="POST" action="/confirm/" data-netlify="true" netlify-honeypot="bot-field">
    <input type="hidden" name="form-name" value="contacting_select" />
    <label>Your Name:</label>   
    <input type="text" name="name" placeholder="yourname"/>
    <label>Your Email:</label>
    <input type="email" name="email" placeholder="you@domain.com" required/>
    <label>What Can I Help You With?:</label>   
    <div>
    <select name="help-with">
    <option value="designing">Designing Something</option>
    <option value="developing">Developing Something</option>
    <option value="measuring">Measuring My Marketing Mix</option>
    <option value="fixing">Fixing Something Up</option>
    <option selected value="all">All of The Things</option>
    <option value="none">None of the Things / Something Else</option>
    </select>
    </div>
    <label>Message:</label>
    <textarea name="message"></textarea>
    <button type="submit">Send</button>
    <div className="formfix">&nbsp;</div>
</form>

    
    
  </div>
)

export default ContactPage



// WEBPACK FOOTER //
// ./src/pages/contact.js